/*
 * Copyright (c) 2023 Pegasystems Inc.
 * All rights reserved.
 */
import Utils from '../../../utils/utils';

class Delete {
  static execute(target: string, index: number, pageReference: string) {
    return {
      target: Utils.buildInstructionPageReference(pageReference, target),
      [typeof index === 'string' ? 'groupIndex' : 'listIndex']: index,
      instruction: 'DELETE'
    };
  }
}
export default Delete;
